import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  toolIcon: {
    width: 20,
    height: 20,
    objectFit: 'contain',
    flexShrink: 0,
  },
  menuItemContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  // Tool metadata strip — horizontal layout with azure accent border
  toolMetaStrip: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(2.5),
    padding: theme.spacing(1.5, 2),
    background: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderLeft: `3px solid ${theme.palette.azure}`,
    borderRadius: theme.shape.borderRadius,
  },
  metaProviderColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    paddingRight: theme.spacing(2.5),
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  metaCategoriesColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 160,
  },
  // Provider badge — pill with icon + name
  providerBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.5, 1.5),
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 100,
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  },
  providerBadgeIcon: {
    width: 18,
    height: 18,
    objectFit: 'contain',
    flexShrink: 0,
    borderRadius: 3,
  },
  providerBadgeText: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1,
  },
  // Category chips row
  categoriesRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
  },
  // Per-category chip color variants (filled style, palette tokens only)
  chipTextGeneration: {
    backgroundColor: `${theme.palette.azure}18`,
    color: theme.palette.azure,
  },
  chipCodeAssistant: {
    backgroundColor: `${theme.palette.teal}18`,
    color: theme.palette.teal,
  },
  chipAgent: {
    backgroundColor: `${theme.palette.trailWarning}18`,
    color: theme.palette.trailWarning,
  },
  chipImageGeneration: {
    backgroundColor: `${theme.palette.pinkMagenta}18`,
    color: theme.palette.pinkMagenta,
  },
  chipVoice: {
    backgroundColor: `${theme.palette.blueViolet}18`,
    color: theme.palette.blueViolet,
  },
  chipVideoGeneration: {
    backgroundColor: `${theme.palette.grapePurple}18`,
    color: theme.palette.grapePurple,
  },
  chipDataAnalysis: {
    backgroundColor: `${theme.palette.greenPantone}18`,
    color: theme.palette.greenPantone,
  },
  chipSearch: {
    backgroundColor: `${theme.palette.yellowOrange}18`,
    color: theme.palette.yellowOrange,
  },
  chipTranslation: {
    backgroundColor: `${theme.palette.blueLight}18`,
    color: theme.palette.blueLight,
  },
  chipProductivity: {
    backgroundColor: `${theme.palette.yellowWarningDark}18`,
    color: theme.palette.yellowWarningDark,
  },
  chipMultimodal: {
    backgroundColor: `${theme.palette.primary.main}12`,
    color: theme.palette.primary.main,
  },
  chipDefault: {
    backgroundColor: theme.palette.secondary.superLight,
    color: theme.palette.text.secondary,
  },
  // Department section
  invalidDepartmentWarning: {
    backgroundColor: theme.palette.warning.light,
    borderRadius: theme.shape.borderRadius,
  },
  invalidDepartmentText: {
    color: theme.palette.warning.dark,
  },
}))

export default useStyles
